
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ButtonInput',
  props: {
    label: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    inputId: {
      type: String,
      required: true
    },
    buttonLabel: {
      type: String,
      default: 'Continue'
    },
    inputWidth: {
      type: String,
      default: 'small'
    },
    buttonType: {
      type: String,
      default: 'secondary'
    },
    to: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    removeYPadding: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  methods: {
    triggerClick(event: Event) {
      this.$emit('click', event)
    }
  }
})
